import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '@deliveroo/consumer-component-library/components/Modal';
import Button from '@deliveroo/consumer-component-library/components/Button';

import InfoBannerModalWhatsappContainer from '../InfoBannerModalWhatsapp';

import { setInfoBannerModalIsOpen } from '../../actions/orderActions';

import { getOrderStatus } from '../../selectors/orderStatusSelectors';

import i18n from '../../utils/i18n';

export class InfoBannerModalContainer extends Component {
  state = { header: '' };

  modalContent = createRef();

  modals = {
    whatsapp: <InfoBannerModalWhatsappContainer ref={this.modalContent} />,
  };

  componentDidUpdate() {
    const modalContent = this.modalContent.current;
    if (modalContent) {
      const header = modalContent.getHeader();

      if (header !== this.state.header) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ header });
      }
    }
  }

  onSave = () => {
    const modalContent = this.modalContent.current;

    if (modalContent && modalContent.onSave) {
      modalContent.onSave();
    }

    this.props.onModalClose();
  };

  render() {
    const { appElement, modalType, isModalOpen, onModalClose } = this.props;

    const modal = this.modals[modalType];

    if (!modal) {
      return null;
    }

    return (
      <Modal
        id="info-modal"
        appElement={appElement}
        type="fullscreen"
        isOpen={isModalOpen}
        onClose={onModalClose}
        closeButtonLabel={i18n.gettext('closeButton.label')}
        headerTitle={this.state.header}
        renderFooter={() => (
          <Button type="primary" onClick={this.onSave} isBlock>
            {i18n.gettext('Save')}
          </Button>
        )}
      >
        {modal}
      </Modal>
    );
  }
}

InfoBannerModalContainer.propTypes = {
  /** The modal type to be rendered */
  modalType: PropTypes.oneOf(['whatsapp']).isRequired,
  /** If there is a modal, where the modal renders */
  appElement: PropTypes.string,
  /** Whether the modal is open */
  isModalOpen: PropTypes.bool,
  /** method to close the info banner modal */
  onModalClose: PropTypes.func,
};

InfoBannerModalContainer.defaultProps = {
  appElement: '#__next',
  isModalOpen: false,
  onModalClose: () => {},
};

export const mapStateToProps = (state) => {
  const infoBanner = getOrderStatus(state).infoBanner;

  return {
    modalType: infoBanner && infoBanner.modalType,
    isModalOpen: infoBanner && infoBanner.isModalOpen,
  };
};

const mapActionsToProps = (dispatch) => ({
  onModalClose: () => dispatch(setInfoBannerModalIsOpen(false)),
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
  null,
  { forwardRef: true },
)(InfoBannerModalContainer);
